import React, { useCallback, useMemo, useState, useRef } from "react";
import { useLocation } from "react-router-dom";
import { useAxios } from "../../common_nextgen/axios/AxiosHelper";
import FunctionKeys from "../../common_nextgen/common_components/FunctionKeys/FunctionKeys";
import useCustomNavigate from "../../common_nextgen/common_components/Navigation/NextGenNavigation";
import Form from "../../common_nextgen/common_components/form/Form";
import { useToast } from "../../common_nextgen/hooks/ToastContext";
import {
  formFields,
  screenInfo,
} from "../DeductibleSchedule/CopyDeductibleSchedueConfig";
import { ROUTE_PATHS } from "../../common_nextgen/utils/Constants";

const CopyDeductibleSchedule = ({ mode }) => {
  const { DEDUCTIBLE_SCHEDULE } = ROUTE_PATHS;
  const location = useLocation();
  const { state: stateVal } = location;
  const [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);
  console.log("current state in form", currentState, previousState);
  const {
    selectedSchedules = [],
    previousScreen = DEDUCTIBLE_SCHEDULE,
    currentIndex: initialIndex = 0,
  } = currentState;
  console.log("sel sch", selectedSchedules);

  const navigateToPage = useCustomNavigate();
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
  const [currentMode, setCurrentMode] = useState(mode);
  // const [initialFormData, setInitialFormData] = useState({});
  const [constraintErrors, setConstraintErrors] = useState([]);
  const toast = useToast();
  const { axios_helper_no_header } = useAxios();

  const lastValidOpcScheduleName = useRef("");
  const initialFormData = useMemo(() => {
    const {
      dscScheduleName: parDscScheduleName = "",
      dscDescription: parDscDescription = "",
      dtlDscScheduleName = "",
      dtlDscDescription = "",
    } = selectedSchedules[currentIndex];
    return {
      parDscScheduleName,
      parDscDescription,
      dtlDscScheduleName,
      dtlDscDescription,
    };
  }, [selectedSchedules, currentIndex]);

  const handleBack = () => {
    const lastScheduleName =
      selectedSchedules[currentIndex]?.dtlDscScheduleName;
    if (lastScheduleName) {
      lastValidOpcScheduleName.current = lastScheduleName;
    }

    if (currentIndex < selectedSchedules.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      const lastRecord = previousState.pop() ?? {};
      const updatedLastRecord = lastValidOpcScheduleName.current
        ? {
            ...lastRecord,
            paramsData: {
              dscScheduleName: lastValidOpcScheduleName.current,
              hiddenRecordIndicator: "Active",
            },
          }
        : lastRecord;
      const updatedPreviousState = [...previousState, updatedLastRecord];
      navigateToPage(previousScreen, updatedPreviousState);
    }
  };

  const getPageTitle = () => {
    const { screenTitle, screenNumber } = screenInfo;
    return (
      <>
        <span className="title">{screenTitle}</span>
        <span>{"-"}</span>
        <span className="screen-number">{screenNumber}</span>
      </>
    );
  };

  const submitForm = async (dataForSubmission) => {
    const data = {
      ...dataForSubmission,
      screenNumber: screenInfo.screenNumber,
    };
    const url = "api/dscDeductibleSchCtrl/copy";
    const verb = "POST";
    try {
      const { responseStatus } = await axios_helper_no_header(
        verb,
        url,
        data,
        null
      );
      toast.current.show({
        severity: "success",
        summary: "",
        detail: responseStatus.message,
        life: 3000,
      });
      selectedSchedules[currentIndex].dtlDscScheduleName =
        data.dtlDscScheduleName;
      selectedSchedules[currentIndex].dtlDscDescription =
        data.dtlDscDescription;
    } catch (error) {
      const {
        responseStatus: { displayErrorFields = null, message },
      } = error.data;
      if (displayErrorFields === null) {
        toast.current.show({
          severity: "error",
          summary: "",
          detail: message,
          life: 3000,
        });
      } else {
        setConstraintErrors(displayErrorFields);
      }
    }
  };

  const [keyFunc, keyName] = useMemo(() => {
    const keyFunc = {};
    const keyName = {};
    keyFunc["F12"] = handleBack;
    keyName["F12"] = "Back";
    return [keyFunc, keyName];
  }, [currentIndex]);

  // useEffect(() => {
  //   const fetchInitialData = async () => {
  //     const url = `api/dscDeductibleSchCtrl/${selectedPriceSchedules[currentIndex]}`;
  //     try {
  //       const { responseData } = await axios_helper_no_header("GET", url, null, null);
  //       setInitialFormData(responseData);
  //     } catch (error) {
  //       const { responseStatus: { message } } = error.data;
  //       toast.current.show({ severity: "error", summary: "", detail: message, life: 3000 });
  //     }
  //   };
  //   fetchInitialData();
  // }, [currentIndex]);

  return (
    <div className="grid container">
      <div className="col col-12">
        <FunctionKeys keyFunc={keyFunc} keyName={keyName} />
      </div>
      <div className="col col-12">
        <h1>{getPageTitle()}</h1>
      </div>
      <div className="col col-12">
        <Form
          formData={initialFormData}
          formFields={formFields}
          mode={mode}
          submitFormData={submitForm}
          constraintErrors={constraintErrors}
        />
      </div>
    </div>
  );
};

export default CopyDeductibleSchedule;
